module.exports = __webpack_public_path__ + "static/media/cardPacoteBgDark.fa52fba7.png";